const config = { domain: 'Impact', subdomain: 'Progress' }

interface GoalProgressUpdate {
  goalId: number
  platformPlan: string | null
  userId: number
  description: string
}

export const progressUpdate = {
  Update_Dismissed: {
    Update_Dismissed: (param: GoalProgressUpdate) => param,
    config,
  },
  Update_Deleted: {
    Update_Deleted: (param: GoalProgressUpdate) => param,
    config,
  },
  Update_Edited: {
    Update_Edited: (param: GoalProgressUpdate) => param,
    config,
  },
  Update_Added: {
    Update_Added: (param: GoalProgressUpdate) => param,
    config,
  },
  Add_Update_Clicked: {
    Add_Update_Clicked: (param: GoalProgressUpdate) => param,
    config,
  },
}
